import { ButtonStyle } from "../components/button"

export type FilePickerError = "file-too-big" | "unsupported-extension"

export interface FilePickerProps {
    style?: ButtonStyle
    t?: any

    onFileSelected(errorReason: FilePickerError | null, file: File | null, fileInfo?: FileInfo | null): void
}

export default class FileInfo {
    readonly name: string
    readonly sizeInBytes: number
    readonly contents: string
    readonly mimeType: string

    constructor(name: string, sizeInBytes: number, contents: string, mimeType: string) {
        this.name = name
        this.sizeInBytes = sizeInBytes
        this.contents = contents
        this.mimeType = mimeType
    }
}
